var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',{staticClass:"head boxed"},[_vm._v(_vm._s(_vm.$t('Результаты поиска')))]),_c('vue-sort'),_c('vue-filter-by-checking'),_c('vue-top'),_c('vue-sold'),_c('vue-size'),_c('vue-advertisement'),_c('vue-photo-video')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }